import * as React from 'react';

import { cn } from '@/lib/cn';

export type DSInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, DSInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          'w-full rounded-md border border-border bg-bg-secondary px-4 py-3 text-text-primary transition-all duration-fast ease-out placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-accent',
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = 'DSInput';
